<template>
  <div>
    <div @click="toggleDropdown" class="dropdown-toggle nav-item">
      {{ MyCategory.FormKbn.find((item) => item.Kbn == 4)?.KbnName }}
    </div>
    <StaffSelect
      :isModalStaffSelectVisible="isModalStaffSelectVisible"
      :staffSelectId="StaffSelectId"
      @selected-action="selectedActionStaffSelect"
      @cancel-action="cancelActionStaffSelect"
    />
    <div v-if="isOpen" class="dropdown-menu">
      <div
        v-for="(staffRole, index) in StaffRole.filter((item:TblMStaffRole) => item.kbn == 4 && item.roleKbn ==1)"
        :key="index"
      >
        <router-link
          :to="staffRole.url ?? ''"
          class="dropdown-item"
          @click="closeDropdown"
          >{{ staffRole.menuName }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import type { Ref } from "vue";
import { RouterLink } from "vue-router";
import CompanyService from "../Js/CompanyService";
import { useStaffSelect } from "@/Js/StaffSelectService";
import StaffSelectService from "@/Js/StaffSelectService";
import StaffSelect from "@/components/StaffSelect.vue";
import MyCategory from "@/Data/MyCategory";
import { TblMStaffRole } from "@/models/TblMStaffRole";
import type { ITblMStaffRoleData } from "@/models/TblMStaffRole";
import axios, { Axios, type AxiosResponse } from "axios";

const companyService = CompanyService; //会社情報、既にexport default new CompanyService();をしている。
const staffSelectService = new StaffSelectService();
const StaffRole: Ref<TblMStaffRole[]> = ref([new TblMStaffRole()]);

const {
  StaffSelectId,
  isModalStaffSelectVisible,
  showStaffSelect,
  closeModalStaffSelect,
  cancelActionStaffSelect,
  selectedActionStaffSelect,
} = useStaffSelect();

const openStaffSelect = () => {
  showStaffSelect(() => {});
};

const isOpen = ref(false);

const props = defineProps({
  isOpenMenu4: Boolean,
});

const toggleDropdown = async() => {
  const company = companyService.getStoredData();
  if (
    company.companyCode != "" &&
    company.officeCode != "" &&
    company.serviceType != ""
  ) {
    if ((staffSelectService.getStaffSelect().staffCode ?? "") == "") {
      await openStaffSelect();
    } else {
      isOpen.value = !isOpen.value;
    }
    await getList();
  }
};

const closeDropdown = () => {
  isOpen.value = false;
};
const getList = async () => {
  try {

    const staffCode:string = staffSelectService.getStaffSelect().staffCode?? '' ;
    if (staffCode && StaffRole.value.length==0) {
      const endpoint: string = `${
        import.meta.env.VITE_API_TARGET
      }/api/MStaffRole/GetListsByStaffCode/${
        staffCode ?? ""
      }`;

      const response = await axios.get(endpoint);
      let staffRole: TblMStaffRole[] = [new TblMStaffRole()];

      if (response.status === 200) {
        staffRole = response.data.map((item: TblMStaffRole) => {

          // 新しいユーザーオブジェクトを作成し、変換された日付を使用
          return new TblMStaffRole({
            ...item,
           });
        });

        StaffRole.value=staffRole;
      }
    }
  } catch{

  }
};

onMounted(async () => {
   axios.defaults.withCredentials = true; //Cookieの場合
  StaffRole.value =[];
});

watch(
  () => props.isOpenMenu4,
  (newValue, oldValue) => {
    if (newValue !== oldValue && newValue == true) {
      isOpen.value = false;
    }
  }
);
</script>

<style scoped>
.dropdown-toggle {
  cursor: pointer;
  padding: 8px;
  background-color: #007bff;
  color: white;
}

.dropdown-menu {
  position: fixed;
  display: block;
  background-color: white;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 50vh;
  overflow-y: auto;
  z-index: 9000 !important;
}

.dropdown-item {
  padding: 8px;
  display: block;
  color: black;
  text-decoration: none;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
